import React from 'react';
import './SettingsSidebar.css';

const SettingsSidebar = ({ activeSection, onSectionChange, isCompanyMode = false }) => {
  const sections = [
    {
      id: 'activity',
      label: isCompanyMode ? 'Company Activity' : 'User Activity',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
        </svg>
      ),
      description: isCompanyMode ? 'View company job reports and activity' : 'View your job reports and activity'
    },
    {
      id: 'general',
      label: 'Email',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
      ),
      description: 'Email verification and sub-email management'
    },
    {
      id: 'passwords',
      label: 'Passwords',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <circle cx="12" cy="16" r="1"></circle>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
      ),
      description: 'Password and security settings'
    },
    {
      id: 'preferences',
      label: 'Preferences',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M12 1v6m0 6v6M5.64 5.64l4.24 4.24m4.24 4.24l4.24 4.24M1 12h6m6 0h6M5.64 18.36l4.24-4.24m4.24-4.24l4.24-4.24"></path>
        </svg>
      ),
      description: 'Manage search preferences and bookmarks'
    },
    {
      id: 'companies',
      label: 'My companies',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9,22 9,12 15,12 15,22"></polyline>
        </svg>
      ),
      description: 'Switch to or close your companies'
    },
    {
      id: 'notifications',
      label: 'Notifications',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
      ),
      description: 'Email and notification preferences'
    },
    {
      id: 'leave-platform',
      label: 'Leave Platform',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 3l18 18"></path>
          <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path>
          <path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path>
          <line x1="12" y1="19" x2="12" y2="23"></line>
          <line x1="8" y1="23" x2="16" y2="23"></line>
        </svg>
      ),
      description: 'Permanently delete your account'
    }
  ];

  // Filter: hide notifications; in company mode hide Passwords, My companies, Leave platform
  const hiddenInCompanyMode = ['passwords', 'companies', 'leave-platform'];
  const visibleSections = sections.filter(section => {
    if (section.id === 'notifications') return false;
    if (isCompanyMode && hiddenInCompanyMode.includes(section.id)) return false;
    return true;
  });

  return (
    <div className="settings-sidebar">
      {/* Desktop Header */}
      <div className="sidebar-header desktop-only">
        <h3>Settings</h3>
        <p>Manage your account preferences</p>
      </div>
      
      {/* Mobile Tab Navigation */}
      <nav className="sidebar-nav mobile-tabs">
        {visibleSections.map((section) => (
          <button
            key={section.id}
            className={`sidebar-item mobile-tab-item ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => onSectionChange(section.id)}
            aria-label={section.label}
          >
            <div className="sidebar-item-icon">
              {section.icon}
            </div>
            <span className="sidebar-item-label">{section.label}</span>
          </button>
        ))}
      </nav>

      {/* Desktop Navigation */}
      <nav className="sidebar-nav desktop-nav">
        {visibleSections.map((section) => (
          <button
            key={section.id}
            className={`sidebar-item ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => onSectionChange(section.id)}
          >
            <div className="sidebar-item-icon">
              {section.icon}
            </div>
            <div className="sidebar-item-content">
              <span className="sidebar-item-label">{section.label}</span>
              <span className="sidebar-item-description">{section.description}</span>
            </div>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default SettingsSidebar;
